<div class="section-full small-device  p-tb80 bg-gray">
  <div class="container ">
      <!-- IMAGE CAROUSEL START -->
      <div class="row">
        <div class="col-md-6 m-b30">
              <!-- TITLE START -->
              <div class="text-left">
                  <h2 class="text-uppercase font-45 font-weight-500 m-b5">Building your visions. Creating reality.</h2>
                  <p>Fited his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly.</p>
                  <a routerLink="/about-1" class="site-button site-btn-effect">Read More</a>
              </div>
              <!-- TITLE END -->                        
          </div>
          
          <div class="col-md-6">
            <div class="video-section-outer">
                <div class="video-section">
                      <img src="assets/images/gallery/pic1.jpg" alt="">
                       <a href="https://player.vimeo.com/video/34741214?color=ffffff&title=0&byline=0&portrait=0" class="mfp-video play-now">
                          <i class="icon fa fa-play"></i>
                          <span class="ripple"></span>
                      </a>                                              
                  </div>
              </div>
          </div>
  
              
       </div>
  </div>
</div>   